import { BffRequestBuilder } from "./Helpers";
/**
 * @method prepareData
 * @description Parse loaded data from BFF to BsUtilItem items
 * @param {EventsByEventIdForBetSlipResponse} response Received response from BFF
 * @return {BsUtilItem[]} Processed items
 */
function prepareData(response) {
    let items = [];
    response.markets.forEach((market) => {
        let event = response.events.find(e => market.eventId === e.id);
        if (!event || !market.selections) {
            return;
        }
        market.selections.forEach(selection => {
            items.push({
                event: event || {},
                market,
                selection
            });
        });
    });
    return items;
}
/**
 * @method loadData
 * @description Get data from 'getEventsByIdForBetslip' BFF endpoint
 * @param {BsUtilMsgItem[]} items Items, to be fetched form BFF
 * @param {Function} successCallback Function, to be executed on successfully loaded and processed items
 * @param {Function} errorCallback Function to be executed when error occured
 */
export function loadData(bff, items, successCallback, errorCallback) {
    const request = BffRequestBuilder.buildEventsByEventIdForBetSlipRequest(items);
    return bff.getEventsByIdForBetslip(request)
        .then((response) => {
        successCallback(prepareData(response));
    })
        .catch(errorCallback);
}
//# sourceMappingURL=LoadData.js.map